// "The Arc" — no heading. Single narrative paragraph explaining the golden
// ticket experience. Intentionally quiet — lets the copy breathe.
export default function TheArc() {
  return (
    <section
      id="arc"
      style={{
        background: "radial-gradient(ellipse 85% 70% at 15% 30%, rgba(239,83,126,0.18) 0%, transparent 55%), radial-gradient(ellipse 75% 70% at 90% 80%, rgba(252,179,31,0.12) 0%, transparent 55%), #15355f",
        padding: "6rem 1.5rem",
        textAlign: "center",
      }}
    >
      <p style={{
        maxWidth: "720px",
        margin: "0 auto",
        fontFamily: "var(--jop-display)",
        fontSize: "clamp(1.1rem, 2.4vw, 1.5rem)",
        lineHeight: 1.65,
        color: "var(--jop-cream)",
        fontWeight: 500,
      }}>
        Every guest gets a <span style={{ color: "var(--jop-gold)", fontWeight: 700 }}>golden ticket</span>. It puts them right at the griddle, close enough to smell the hot batter. After the flip, after they've held it warm and eaten it, the ticket stays with them. They scan it and find their <span style={{ color: "var(--jop-pink)", fontWeight: 700 }}>pancake preserved</span> in a <span style={{ color: "var(--jop-highlight-blue)", fontWeight: 700 }}>gallery</span> all their own.
      </p>
    </section>
  );
}
